// Register GSAP ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// Normalize scroll for touch devices (helps with mobile browsers)
if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
  ScrollTrigger.normalizeScroll(true);
}

// City data from radioData.json
const radioData = {
  cities: [
    { key: "Amsterdam", name: "Amsterdam", lat: 52.3676, lng: 7.9041 },
    { key: "Berlin", name: "Berlin", lat: 50.5200, lng: 13.4050 },
    { key: "Paris", name: "Paris", lat: 48.8566, lng: 2.3522 },
    { key: "Istanbul", name: "Istanbul", lat: 41.0082, lng: 28.9784 },
    { key: "Tokyo", name: "Tokyo", lat: 35.6762, lng: 139.6503 },
    { key: "Lisboa", name: "Lisboa", lat: 38.7223, lng: -9.1393 },
    { key: "London", name: "London", lat: 55.9974, lng: -3.1778 },
    { key: "MexicoCity", name: "Mexico City", lat: 19.4326, lng: -99.1332 },
    { key: "Montreal", name: "Montreal", lat: 47.5017, lng: -83.5673 },
    { key: "NewYork", name: "New York", lat: 40.7128, lng: -74.0060 },
    { key: "Seoul", name: "Seoul", lat: 37.5665, lng: 126.9780 },
    { key: "Shanghai", name: "Shanghai", lat: 33.2304, lng: 119.4737 },
    { key: "Taipei", name: "Taipei", lat: 25.0330, lng: 121.5654 },
    { key: "Thailand", name: "Bangkok", lat: 13.7563, lng: 100.5018 },
    { key: "Vancouver", name: "Vancouver", lat: 49.2827, lng: -123.1207 },
    { key: "Sydney", name: "Sydney", lat: -33.8688, lng: 151.2093 },
    { key: "Melbourne", name: "Melbourne", lat: -37.8136, lng: 144.9631 },
    { key: "LosAngeles", name: "Los Angeles", lat: 34.0522, lng: -118.2437 },
    { key: "Barcelona", name: "Barcelona", lat: 41.3851, lng: -5.1734 },
    { key: "Roma", name: "Roma", lat: 41.9028, lng: 12.4964 },
    { key: "Singapore", name: "Singapore", lat: 1.3521, lng: 103.8198 },
    { key: "Bali", name: "Bali", lat: -8.3405, lng: 115.0920 },
    { key: "Dubai", name: "Dubai", lat: 25.2048, lng: 55.2708 },
    { key: "Manama", name: "Manama", lat: 26.2285, lng: 50.5860 },
    { key: "Cairo", name: "Cairo", lat: 30.0444, lng: 31.2357 },
    { key: "Ramallah", name: "Ramallah", lat: 31.9038, lng: 35.2034 },
    { key: "Beirut", name: "Beirut", lat: 33.8938, lng: 35.5018 }
  ]
};

// Create cities lookup
const cities = {};
const cityNameToKey = {};
radioData.cities.forEach(city => {
  cities[city.key] = {
    key: city.key,
    lat: city.lat,
    lng: city.lng,
    name: city.name
  };
  cityNameToKey[city.name] = city.key;
});

// Map SVG city IDs to city keys
const svgIdToCityKey = {
  'new-york': 'NewYork',
  'london': 'London',
  'paris': 'Paris',
  'amsterdam': 'Amsterdam',
  'berlin': 'Berlin',
  'istanbul': 'Istanbul',
  'seoul': 'Seoul',
  'tokyo': 'Tokyo',
  'shanghai': 'Shanghai',
  'los-angeles': 'LosAngeles',
  'mexico-city': 'MexicoCity',
  'barcelona': 'Barcelona',
  'lisboa': 'Lisboa',
  'taipei': 'Taipei',
  'montreal': 'Montreal',
  'vancouver': 'Vancouver',
  'roma': 'Roma',
  'bangkok': 'Thailand',
  'sydney': 'Sydney',
  'melbourne': 'Melbourne',
  'singapore': 'Singapore',
  'bali': 'Bali',
  'dubai': 'Dubai',
  'manama': 'Manama',
  'cairo': 'Cairo',
  'ramallah': 'Ramallah',
  'beirut': 'Beirut'
};

// Map city keys to display names
const cityKeyToDisplayName = {
  'NewYork': 'New York',
  'London': 'London',
  'Paris': 'Paris',
  'Amsterdam': 'Amsterdam',
  'Berlin': 'Berlin',
  'Istanbul': 'Istanbul',
  'Seoul': 'Seoul',
  'Tokyo': 'Tokyo',
  'Shanghai': 'Shanghai',
  'LosAngeles': 'Los Angeles',
  'MexicoCity': 'Mexico City',
  'Barcelona': 'Barcelona',
  'Lisboa': 'Lisboa',
  'Taipei': 'Taipei',
  'Montreal': 'Montreal',
  'Vancouver': 'Vancouver',
  'Roma': 'Roma',
  'Thailand': 'Bangkok',
  'Sydney': 'Sydney',
  'Melbourne': 'Melbourne',
  'Singapore': 'Singapore',
  'Bali': 'Bali',
  'Dubai': 'Dubai',
  'Manama': 'Manama',
  'Cairo': 'Cairo',
  'Ramallah': 'Ramallah',
  'Beirut': 'Beirut'
};

// City to artists mapping and Artist data
// Use data from Shopify blocks if available (window.worldMapData), otherwise use fallback data
const CITY_ARTISTS_DATA = (typeof window !== 'undefined' && window.worldMapData && window.worldMapData.cityArtists) 
  ? window.worldMapData.cityArtists
  : [
      { cityKey: "Amsterdam", artistIds: [] },
      { cityKey: "Berlin", artistIds: [] },
      { cityKey: "Paris", artistIds: [] },
      { cityKey: "Istanbul", artistIds: [] },
      { cityKey: "Tokyo", artistIds: [] },
      { cityKey: "Lisboa", artistIds: [] },
      { cityKey: "London", artistIds: [] },
      { cityKey: "MexicoCity", artistIds: [] },
      { cityKey: "Montreal", artistIds: [] },
      { cityKey: "NewYork", artistIds: [] },
      { cityKey: "Seoul", artistIds: [] },
      { cityKey: "Shanghai", artistIds: [] },
      { cityKey: "Taipei", artistIds: [] },
      { cityKey: "Thailand", artistIds: [] },
      { cityKey: "Vancouver", artistIds: [] },
      { cityKey: "Sydney", artistIds: [] },
      { cityKey: "Melbourne", artistIds: [] },
      { cityKey: "LosAngeles", artistIds: [] },
      { cityKey: "Barcelona", artistIds: [] },
      { cityKey: "Roma", artistIds: [] },
      { cityKey: "Singapore", artistIds: [] },
      { cityKey: "Bali", artistIds: [] },
      { cityKey: "Dubai", artistIds: [] },
      { cityKey: "Manama", artistIds: [] },
      { cityKey: "Cairo", artistIds: [] },
      { cityKey: "Ramallah", artistIds: [] },
      { cityKey: "Beirut", artistIds: [] }
    ];

const ARTISTS_DATA = (typeof window !== 'undefined' && window.worldMapData && window.worldMapData.artists) 
  ? window.worldMapData.artists
  : [];

// Helper function to get artist IDs for a city
function getArtistIdsForCity(cityKey) {
  const cityData = CITY_ARTISTS_DATA.find(city => city.cityKey === cityKey);
  return cityData ? cityData.artistIds : [];
}

// Main application state
const state = {
  svgDimensions: { width: 0, height: 0 },
  cityCoords: {},
  modalCity: null,
  modalCityData: null,
  modalArtists: [],
  modalPosition: null,
  rawClickPosition: null
};

// Get DOM elements
const svgRef = document.getElementById('world-map-svg');
const containerRef = document.querySelector('.svg-container');
const scrollWrapperRef = document.querySelector('.svg-scroll-wrapper');
const modalContainer = document.getElementById('modal-container');
const modalCityName = document.getElementById('modal-city-name');
const modalArtistsList = document.getElementById('modal-artists-list');
const modalNoArtists = document.getElementById('modal-no-artists');
const modalClose = document.querySelector('.modal-close');
const cityLabelsContainer = document.getElementById('city-labels-container');

// Function to convert SVG coordinates to screen coordinates
function getScreenCoordinates(svgX, svgY) {
  if (state.svgDimensions.width === 0 || state.svgDimensions.height === 0) {
    return { x: 0, y: 0 };
  }
  
  const viewBoxWidth = 1002;
  const viewBoxHeight = 484;
  
  const scaleX = state.svgDimensions.width / viewBoxWidth;
  const scaleY = state.svgDimensions.height / viewBoxHeight;
  
  return {
    x: svgX * scaleX,
    y: svgY * scaleY
  };
}

// Extract city coordinates from path elements
function extractCityCoords() {
  if (!svgRef) return;
  
  const coords = {};
  const cityPaths = svgRef.querySelectorAll('path[id]');
  
  cityPaths.forEach((path) => {
    const id = path.getAttribute('id');
    if (id && svgIdToCityKey[id]) {
      try {
        const bbox = path.getBBox();
        coords[id] = {
          x: bbox.x + bbox.width / 2,
          y: bbox.y + bbox.height / 2,
          width: bbox.width,
          height: bbox.height
        };
      } catch (e) {
        // Fallback: extract from path data
        const pathData = path.getAttribute('d');
        if (pathData) {
          const match = pathData.match(/M([\d.]+)\s+([\d.]+)/);
          if (match) {
            coords[id] = {
              x: parseFloat(match[1]),
              y: parseFloat(match[2])
            };
          }
        }
      }
    }
  });
  
  state.cityCoords = coords;
}

// Update SVG dimensions
function updateDimensions() {
  if (svgRef) {
    const rect = svgRef.getBoundingClientRect();
    state.svgDimensions = { width: rect.width, height: rect.height };
    renderCityLabels();
  }
}

// Label placement. Top labels sit above the map in two rows, bottom labels below it in one row.
// "Left" cities have their label to the left of the line, "Right" cities to the right of it.
const topLeftCities = ['Montreal', 'London', 'Paris', 'Bangkok', 'Taipei', 'Shanghai'];
const topRightCities = ['Vancouver', 'New York', 'Amsterdam', 'Berlin', 'Istanbul', 'Beirut', 'Manama', 'Tokyo', 'Seoul'];
const bottomLeftCities = ['Los Angeles', 'Lisboa', 'Barcelona', 'Roma', 'Singapore', 'Bali', 'Melbourne'];
const bottomRightCities = ['Mexico City', 'Cairo', 'Ramallah', 'Dubai', 'Sydney'];
// Top cities placed in the upper row (all other top cities use the lower row)
const upperRowCities = ['Paris', 'Amsterdam', 'Istanbul', 'Bangkok'];

// Cities whose line is drawn as an elbow (vertical from the label, then horizontal into the pin)
// instead of a straight vertical line. offsetX shifts the label sideways from the pin, in map
// units (the SVG viewBox is 1002 wide; negative = left, positive = right). Because it is in map
// units it scales with the map, so the horizontal part is automatically shorter on mobile.
const elbowCities = {
  'Vancouver': { offsetX: -72 },
  'Istanbul': { offsetX: 40 },
  'Beirut': { offsetX: 40 },
  'Manama': { offsetX: 62 },
  'Lisboa': { offsetX: -73 },
  'Singapore': { offsetX: -37 }
};

// Y position (px) the label row of a city sits at
function getCityLabelY(city) {
  if (upperRowCities.includes(city)) return 30;
  if (topLeftCities.includes(city) || topRightCities.includes(city)) return 70;
  return state.svgDimensions.height - 60;
}

// Rows a label can sit in, as its `top` offset in px, in order of preference. The first one is the
// row from the design; the others are only used when the label would collide with another label
// (mostly on mobile, where the map is narrower but the text is not).
function getLabelRowOptions(isTop, isUpperRow) {
  const h = state.svgDimensions.height;
  if (!isTop) return [h, h - 40, h - 80, h + 40];
  return isUpperRow ? [-50, -10, -90, 30] : [-10, -50, 30, -90];
}

// Pick a row for every label so that no two labels overlap and no line runs through another
// label's text. Lines run from a label towards the map, so they cross every row nearer the map.
function assignLabelRows(labels) {
  const gap = 4;
  const placed = [];
  const isNearerMap = (isTop, rowA, rowB) => (isTop ? rowA > rowB : rowA < rowB);
  const lineCrosses = (lineX, label) => lineX > label.left - gap && lineX < label.right + gap;

  const fits = (label, row) => placed.every(other => {
    if (other.isTop !== label.isTop) return true;
    if (other.row === row) return label.right + gap <= other.left || other.right + gap <= label.left;
    if (isNearerMap(label.isTop, other.row, row)) return !lineCrosses(label.lineX, other);
    return !lineCrosses(other.lineX, label);
  });

  labels.slice().sort((a, b) => a.left - b.left).forEach(label => {
    label.row = label.rowOptions.find(row => fits(label, row)) ?? label.rowOptions[0];
    placed.push(label);
  });
}

// Draw a label's line into its pin: straight down/up, or as an elbow (vertical from the label,
// then horizontal into the side of the pin)
function drawLabelLine(label) {
  const containerRect = containerRef.getBoundingClientRect();
  const pRect = label.p.getBoundingClientRect();

  // Snap to whole device pixels so every line renders equally thin and crisp, also on screens
  // with display scaling (where a 1px CSS line can otherwise cover 1 or 2 physical pixels)
  const dpr = window.devicePixelRatio || 1;
  const snap = value => Math.round(value * dpr) / dpr;
  const lineWidth = Math.max(1, Math.round(dpr)) / dpr;

  // Snap in page coordinates (the container itself may sit on a fractional pixel)
  const left = containerRect.left;
  const top = containerRect.top;
  const lineX = snap(label.isRightAligned ? pRect.left : pRect.right - 1) - left;
  const labelEdgeY = snap(label.isTop ? pRect.bottom : pRect.top) - top;

  const pin = getScreenCoordinates(label.coords.x, label.coords.y);
  const pinHalf = getScreenCoordinates((label.coords.width || 0) / 2, (label.coords.height || 0) / 2);
  const pinY = snap(top + pin.y) - top;
  const lineEndY = label.elbow ? pinY : snap(top + (label.isTop ? pin.y - pinHalf.y : pin.y + pinHalf.y)) - top;

  const lineStyle = 'position: absolute; background-color: #000000; z-index: 1; pointer-events: none;';

  const vertical = document.createElement('div');
  vertical.style.cssText = `${lineStyle} left: ${lineX}px; top: ${Math.min(labelEdgeY, lineEndY)}px; width: ${lineWidth}px; height: ${Math.abs(labelEdgeY - lineEndY)}px;`;
  cityLabelsContainer.appendChild(vertical);

  if (label.elbow) {
    const pinEdgeX = snap(left + (lineX < pin.x ? pin.x - pinHalf.x : pin.x + pinHalf.x)) - left;
    const horizontal = document.createElement('div');
    horizontal.style.cssText = `${lineStyle} left: ${Math.min(lineX, pinEdgeX)}px; top: ${pinY}px; width: ${Math.abs(pinEdgeX - lineX) + lineWidth}px; height: ${lineWidth}px;`;
    cityLabelsContainer.appendChild(horizontal);
  }
}

// Render city labels
function renderCityLabels() {
  if (!cityLabelsContainer) return;
  
  cityLabelsContainer.innerHTML = '';
  const labels = [];
  
  Object.entries(state.cityCoords).forEach(([svgId, coords]) => {
    const cityKey = svgIdToCityKey[svgId];
    if (!cityKey || !cities[cityKey]) return;
    
    const city = cityKeyToDisplayName[cityKey] || cities[cityKey].name;
    const screenCoords = getScreenCoordinates(coords.x, coords.y);
    
    const isTopCity = topLeftCities.includes(city) || topRightCities.includes(city);
    const isRightAligned = topRightCities.includes(city) || bottomRightCities.includes(city);
    const elbow = elbowCities[city];
    const cityY = getCityLabelY(city);
    
    const labelDiv = document.createElement('div');
    labelDiv.className = 'city-label';
    labelDiv.style.left = `${screenCoords.x + (elbow ? getScreenCoordinates(elbow.offsetX, 0).x : 0)}px`;
    labelDiv.style.transform = isRightAligned ? 'translate(0%, -120%)' : 'translate(-100%, -120%)';
    
    const innerDiv = document.createElement('div');
    innerDiv.style.position = 'relative';
    
    const p = document.createElement('p');
    p.textContent = city;
    p.style.textTransform = 'lowercase';
    if (isTopCity) {
      p.style.borderBottom = '1px solid #000000';
      p.style.paddingBottom = '4px';
    } else {
      p.style.borderTop = '1px solid #000000';
      p.style.paddingTop = '4px';
      p.style.marginBottom = '-24px';
    }
    
    p.addEventListener('click', () => {
      handleCityClick(svgId, { clientX: screenCoords.x, clientY: cityY });
    });
    
    innerDiv.appendChild(p);
    labelDiv.appendChild(innerDiv);
    cityLabelsContainer.appendChild(labelDiv);

    labels.push({
      div: labelDiv,
      p,
      coords,
      elbow,
      isTop: isTopCity,
      isRightAligned,
      rowOptions: getLabelRowOptions(isTopCity, upperRowCities.includes(city))
    });
  });

  // Measure each label's text and line position (horizontal only, so the row doesn't matter yet)
  const containerLeft = containerRef.getBoundingClientRect().left;
  labels.forEach(label => {
    const rect = label.p.getBoundingClientRect();
    label.left = rect.left - containerLeft;
    label.right = rect.right - containerLeft;
    label.lineX = label.isRightAligned ? label.left : label.right - 1;
  });

  assignLabelRows(labels);

  labels.forEach(label => {
    label.div.style.top = `${label.row}px`;
    drawLabelLine(label);
  });
}

// Handle city path click
function handleCityClick(svgId, event) {
  const cityKey = svgIdToCityKey[svgId];
  if (!cityKey || !cities[cityKey]) return;

  const cityName = cityKeyToDisplayName[cityKey] || cities[cityKey].name;
  state.modalCity = cityName;
  state.modalCityData = cities[cityKey];
  
  const artistIds = getArtistIdsForCity(cityKey);
  const artists = artistIds
    .map(id => ARTISTS_DATA.find(artist => artist.id === id))
    .filter(Boolean);
  state.modalArtists = artists;

  // Get click coordinates
  const coords = state.cityCoords[svgId];
  if (coords) {
    const screenCoords = getScreenCoordinates(coords.x, coords.y);
    
    const cityY = getCityLabelY(cityName);
    const clickCoords = { x: screenCoords.x, y: cityY };
    state.modalPosition = clickCoords;
    state.rawClickPosition = clickCoords;
  } else {
    // Fallback to click position
    if (svgRef) {
      const rect = svgRef.getBoundingClientRect();
      const clickCoords = {
        x: event.clientX - rect.left,
        y: event.clientY - rect.top
      };
      state.modalPosition = clickCoords;
      state.rawClickPosition = clickCoords;
    }
  }
  
  showModal();
}

// Show modal
function showModal() {
  if (!modalContainer || !state.modalPosition) return;
  
  // Clamp modal position
  const bounds = containerRef.getBoundingClientRect();
  const width = bounds.width;
  const height = bounds.height;
  const margin = 40;
  const modalWidth = modalContainer.offsetWidth || 300;
  const modalHeight = modalContainer.offsetHeight || 400;
  
  const minCenterX = margin + modalWidth / 2;
  const maxCenterX = width - margin - modalWidth / 2;
  const clampedCenterX = Math.max(minCenterX, Math.min(maxCenterX, state.rawClickPosition.x));
  const clampedY = Math.max(margin + 8, Math.min(height - margin - 8, state.rawClickPosition.y));
  
  state.modalPosition = { x: clampedCenterX, y: clampedY };
  
  // Update modal content
  modalCityName.textContent = state.modalCity;
  
  if (state.modalArtists && state.modalArtists.length > 0) {
    modalNoArtists.style.display = 'none';
    modalArtistsList.innerHTML = '';
    
    state.modalArtists.forEach(artist => {
      const artistItem = document.createElement('a');
      artistItem.href = artist.profileUrl || '#';
      
      const itemDiv = document.createElement('div');
      itemDiv.className = 'modal-artist-item';
      
      const avatar = document.createElement('div');
      avatar.className = 'artist-avatar';
      if (artist.avatarUrl && artist.avatarUrl.trim() !== '') {
        const img = document.createElement('img');
        img.src = artist.avatarUrl;
        img.alt = `${artist.name} avatar`;
        img.className = 'avatar-image';
        img.onerror = function() {
          // If image fails to load, show placeholder instead
          console.warn('Failed to load avatar for', artist.name, 'URL:', artist.avatarUrl);
          avatar.innerHTML = '';
          const placeholder = document.createElement('div');
          placeholder.className = 'avatar-placeholder';
          placeholder.textContent = artist.name.charAt(0).toUpperCase();
          avatar.appendChild(placeholder);
        };
        avatar.appendChild(img);
      } else {
        const placeholder = document.createElement('div');
        placeholder.className = 'avatar-placeholder';
        placeholder.textContent = artist.name.charAt(0).toUpperCase();
        avatar.appendChild(placeholder);
      }
      
      const info = document.createElement('div');
      info.className = 'modal-artist-info';
      
      const nameContainer = document.createElement('div');
      nameContainer.className = 'modal-artist-name-container';
      
      const name = document.createElement('h3');
      name.className = 'modal-artist-name';
      name.textContent = artist.name;
      nameContainer.appendChild(name);
      
      info.appendChild(nameContainer);
      itemDiv.appendChild(avatar);
      itemDiv.appendChild(info);
      artistItem.appendChild(itemDiv);
      modalArtistsList.appendChild(artistItem);
    });
  } else {
    modalNoArtists.style.display = 'block';
    modalArtistsList.innerHTML = '';
  }
  
  // Position and show modal
  modalContainer.style.left = `${state.modalPosition.x}px`;
  modalContainer.style.top = `${state.modalPosition.y}px`;
  modalContainer.style.transform = 'translate(-50%, -100%)';
  modalContainer.style.display = 'block';
}

// Hide modal
function hideModal() {
  if (modalContainer) {
    modalContainer.style.display = 'none';
  }
  state.modalCity = null;
  state.modalCityData = null;
  state.modalArtists = [];
  state.modalPosition = null;
  state.rawClickPosition = null;
}

// Store cleanup function for ScrollTrigger
let scrollTriggerCleanup = null;
let scrollTriggerInstance = null;
let isInitializing = false; // Prevent multiple simultaneous initializations
let initTimeoutIds = []; // Track all initialization timeouts

// Debug helper functions (available in console)
window.toggleScrollMarkers = function() {
  const allTriggers = ScrollTrigger.getAll();
  allTriggers.forEach(trigger => {
    trigger.vars.markers = !trigger.vars.markers;
    trigger.refresh();
  });
  console.log('[GSAP Debug] Markers toggled. Current state:', allTriggers.map(t => t.vars.markers));
};

window.getScrollTriggerInfo = function() {
  console.log('[GSAP Debug] ScrollTrigger Instance:', scrollTriggerInstance);
  console.log('[GSAP Debug] All ScrollTriggers:', ScrollTrigger.getAll());
  console.log('[GSAP Debug] Container:', containerRef);
  console.log('[GSAP Debug] Wrapper:', scrollWrapperRef);
  if (containerRef) {
    const rect = containerRef.getBoundingClientRect();
    console.log('[GSAP Debug] Container dimensions:', {
      width: rect.width,
      height: rect.height,
      expectedWidth: window.innerWidth * 2
    });
  }
  return {
    instance: scrollTriggerInstance,
    allTriggers: ScrollTrigger.getAll(),
    container: containerRef,
    wrapper: scrollWrapperRef
  };
};

// Initialize GSAP scroll animation for mobile
function initScrollAnimation() {
  if (!containerRef || !scrollWrapperRef) return;
  
  const isMobile = window.innerWidth <= 768;
  
  if (isMobile) {
    const container = containerRef;
    const wrapper = scrollWrapperRef;
    
    // Clean up any existing ScrollTrigger instances and pending initializations
    if (scrollTriggerCleanup) {
      scrollTriggerCleanup();
      scrollTriggerCleanup = null;
    }
    
    // Clear any pending initialization attempts
    initTimeoutIds.forEach(id => clearTimeout(id));
    initTimeoutIds = [];
    isInitializing = false;
    
    const setupScrollAnimation = () => {
      // Force a reflow to ensure container has rendered
      void container.offsetHeight;
      
      // Reset container to start position (x: 0) - showing leftmost side
      // Clear any existing transforms first
      gsap.killTweensOf(container);
      gsap.set(container, { clearProps: "all" });
      gsap.set(container, { x: 0 });
      
      // Force another reflow after reset
      void container.offsetHeight;
      
      // Get the actual width - use both scrollWidth and getBoundingClientRect for accuracy
      const containerRect = container.getBoundingClientRect();
      const containerScrollWidth = container.scrollWidth;
      const containerWidth = Math.max(containerRect.width, containerScrollWidth);
      
      // Use visualViewport if available (better for mobile browsers with address bar)
      let viewportWidth = window.innerWidth;
      if (window.visualViewport && window.visualViewport.width) {
        viewportWidth = window.visualViewport.width;
      }
      
      // Verify container is at x: 0
      const currentX = gsap.getProperty(container, "x");
      console.log('[GSAP Debug] Container reset to x:', currentX);
      
      // Container should be 200vw, which is 2 * viewportWidth
      // To show the rightmost edge and add extra space on the right, we need to scroll more
      // Add extra scroll distance (e.g., 50px) to create space on the right
      const extraRightSpace = 50; // Extra pixels to scroll past the right edge
      const scrollDistance = viewportWidth + extraRightSpace; // 100vw + extra space
      
      // Calculate the exact X position needed to show rightmost edge with extra space
      // When X = -(viewportWidth + extraRightSpace), we scroll past the right edge
      const targetX = -(viewportWidth + extraRightSpace);
      
      console.log('[GSAP Debug] Initializing ScrollTrigger:', {
        viewportWidth,
        containerWidth,
        containerScrollWidth,
        expectedWidth: viewportWidth * 2,
        scrollDistance,
        startX: 0,
        targetX
      });
      
      // Kill any existing animations
      ScrollTrigger.getAll().forEach(trigger => {
        if (trigger.vars.trigger === wrapper) {
          console.log('[GSAP Debug] Killing existing trigger');
          trigger.kill();
        }
      });
      
      // Create scroll trigger animation
      // Container is already at x: 0, so we animate from current position (0) to targetX
      const scrollAnimation = gsap.to(container, {
        x: targetX, // Move from 0 to targetX (rightmost position)
        ease: "none",
        scrollTrigger: {
          trigger: wrapper,
          start: "center center", // Center the element when pinning starts
          end: () => `+=${scrollDistance}`,
          scrub: true,
          pin: true, // Pin the trigger element (wrapper)
          pinSpacing: true, // This adds space for the pin
          pinReparent: false, // Don't reparent to body to avoid mobile issues
          anticipatePin: 1,
          invalidateOnRefresh: true, // Recalculate on resize
          fastScrollEnd: true, // Better performance on mobile
          onEnter: () => {
            // Ensure container is at x: 0 when entering the trigger
            const currentX = parseFloat(gsap.getProperty(container, "x") || 0);
            if (Math.abs(currentX) > 0.1) {
              gsap.set(container, { x: 0 });
              console.log('[GSAP Debug] ScrollTrigger entered - container reset to x: 0 (was:', currentX, ')');
            }
          },
          onStart: () => {
            console.log('[GSAP Debug] ScrollTrigger started');
            console.log('[GSAP Debug] Container x at start:', gsap.getProperty(container, "x"));
          },
          onUpdate: (self) => {
            if (self.progress === 0) {
              const currentX = parseFloat(gsap.getProperty(container, "x") || 0);
              console.log('[GSAP Debug] At start (progress 0) - container x:', currentX);
            }
            if (self.progress >= 0.99) {
              const currentX = parseFloat(gsap.getProperty(container, "x") || 0);
              console.log('[GSAP Debug] At end (progress ~1) - container x:', currentX, 'target:', targetX);
            }
          },
          onComplete: () => {
            console.log('[GSAP Debug] ScrollTrigger completed - container x:', gsap.getProperty(container, "x"));
          },
          onRefresh: () => {
            console.log('[GSAP Debug] ScrollTrigger refreshed');
            // Reset to start position on refresh if not actively scrolling
            const currentX = parseFloat(gsap.getProperty(container, "x") || 0);
            if (Math.abs(currentX) > 0.1) {
              gsap.set(container, { x: 0 });
              console.log('[GSAP Debug] Container reset to x: 0 on refresh');
            }
          }
        }
      });
      
      scrollTriggerInstance = scrollAnimation.scrollTrigger;
      console.log('[GSAP Debug] ScrollTrigger created:', scrollTriggerInstance);
      console.log('[GSAP Debug] ScrollTrigger details:', {
        trigger: scrollTriggerInstance.trigger,
        start: scrollTriggerInstance.start,
        end: scrollTriggerInstance.end,
        pin: scrollTriggerInstance.pin,
        markers: scrollTriggerInstance.vars.markers
      });
      
      // Refresh ScrollTrigger to ensure it recalculates
      ScrollTrigger.refresh();
      
      // Force a small delay and refresh again to ensure everything is calculated
      setTimeout(() => {
        ScrollTrigger.refresh();
        console.log('[GSAP Debug] ScrollTrigger refreshed after delay');
      }, 100);
      
      // Store cleanup function
      scrollTriggerCleanup = () => {
        console.log('[GSAP Debug] Cleaning up ScrollTrigger');
        if (scrollAnimation && scrollAnimation.scrollTrigger) {
          scrollAnimation.scrollTrigger.kill();
        }
        ScrollTrigger.getAll().forEach(trigger => {
          if (trigger.vars.trigger === wrapper) {
            trigger.kill();
          }
        });
        scrollTriggerInstance = null;
      };
    };
    
    // Initialize after container has fully rendered
    // Use multiple attempts to ensure we get accurate measurements
    // Mobile devices need more time for layout to settle
    let initAttempted = false; // Track if we've successfully initialized
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const initDelay = isTouchDevice ? 300 : 100; // Longer delay for touch devices
    
    const attemptInit = () => {
      // Prevent multiple simultaneous initializations
      if (isInitializing || initAttempted) {
        console.log('[GSAP Debug] Init already in progress or completed, skipping');
        return;
      }
      
      // Use visualViewport if available for better mobile accuracy
      let viewportWidth = window.innerWidth;
      if (window.visualViewport && window.visualViewport.width) {
        viewportWidth = window.visualViewport.width;
      }
      
      const containerRect = container.getBoundingClientRect();
      const expectedWidth = viewportWidth * 2; // 200vw
      
      console.log('[GSAP Debug] Attempting init:', {
        containerWidth: containerRect.width,
        expectedWidth,
        viewportWidth,
        ratio: containerRect.width / expectedWidth,
        isTouchDevice
      });
      
      // If container hasn't reached expected width yet, wait a bit more
      if (containerRect.width < expectedWidth * 0.95) {
        const timeoutId = setTimeout(attemptInit, isTouchDevice ? 100 : 50);
        initTimeoutIds.push(timeoutId);
        return;
      }
      
      // Mark as initializing to prevent duplicates
      isInitializing = true;
      try {
        setupScrollAnimation();
        initAttempted = true;
      } catch (error) {
        console.error('[GSAP Debug] Error during setup:', error);
        initAttempted = false;
      } finally {
        isInitializing = false;
      }
    };
    
    // Start initialization with longer delay for mobile
    const initialTimeout = setTimeout(() => {
      if (!initAttempted && !isInitializing) {
        attemptInit();
      }
    }, initDelay);
    initTimeoutIds.push(initialTimeout);
  } else {
    // Not mobile - clean up any existing ScrollTrigger
    if (scrollTriggerCleanup) {
      scrollTriggerCleanup();
      scrollTriggerCleanup = null;
    }
    // Clear any pending mobile initialization
    initTimeoutIds.forEach(id => clearTimeout(id));
    initTimeoutIds = [];
    isInitializing = false;
  }
}

// Insert SVG paths
// Load paths from external file or include them inline
function insertSvgPaths() {
  if (!svgRef) return;
  
  // Check if paths are already in SVG (for Shopify Liquid where paths are inline)
  // This should be checked FIRST to avoid any unnecessary operations
  const existingPaths = svgRef.querySelectorAll('path');
  if (existingPaths.length > 0) {
    // Paths are already in the SVG, just initialize
    extractCityCoords();
    updateDimensions();
    addCityClickHandlers();
    return;
  }
  
  // Try to load paths from script tag (alternative method)
  const pathsScript = document.getElementById('svg-paths-data');
  if (pathsScript && pathsScript.textContent.trim()) {
    svgRef.innerHTML = pathsScript.textContent.trim();
    // Re-initialize after paths are loaded
    setTimeout(() => {
      extractCityCoords();
      updateDimensions();
      addCityClickHandlers();
    }, 100);
    return;
  }
  
  // Fallback: Try to fetch from file (only works if file is accessible)
  // Only try this if no paths exist and no script tag exists
  fetch('svg-paths-complete.txt')
    .then(response => {
      if (!response.ok) throw new Error('File not found');
      return response.text();
    })
    .then(paths => {
      if (paths && paths.trim()) {
        svgRef.innerHTML = paths;
        // Re-initialize after paths are loaded
        setTimeout(() => {
          extractCityCoords();
          updateDimensions();
          addCityClickHandlers();
        }, 100);
      }
    })
    .catch(err => {
      console.warn('Could not load SVG paths. Please include them in the HTML or inline in this function.');
      console.warn('Paths are available in svg-paths-complete.txt');
      console.warn('For Shopify Liquid, paste all paths from svg-paths-complete.txt directly inside the <svg> element in world-map.html');
    });
}

// Add click handlers to city paths
function addCityClickHandlers() {
  if (!svgRef) return;
  
  const cityPaths = svgRef.querySelectorAll('path[id]');
  cityPaths.forEach(path => {
    path.addEventListener('click', (e) => {
      const svgId = path.getAttribute('id');
      if (svgId) {
        handleCityClick(svgId, e);
      }
    });
  });
}

// Initialize application
function init() {
  // Insert SVG paths first
  insertSvgPaths();
  
  // Wait for SVG to render, then extract coordinates
  // Use longer delay for mobile devices
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const initDelay = isTouchDevice ? 300 : 100;
  
  setTimeout(() => {
    extractCityCoords();
    updateDimensions();
    addCityClickHandlers();
    initScrollAnimation();
  }, initDelay);
  
  // Update dimensions on resize
  let resizeTimeout;
  const handleResize = () => {
    updateDimensions();
    
    // Debounce resize to avoid too many recalculations
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      // Re-initialize ScrollTrigger on resize (especially when switching mobile/desktop)
      initScrollAnimation();
      ScrollTrigger.refresh();
      console.log('[GSAP Debug] Window resized, ScrollTrigger re-initialized');
    }, 250);
  };
  
  window.addEventListener('resize', handleResize);
  
  // Listen to visualViewport changes on mobile (address bar show/hide)
  // Only listen to resize, not scroll (scroll causes too many refreshes)
  if (window.visualViewport) {
    let viewportResizeTimeout;
    window.visualViewport.addEventListener('resize', () => {
      // Debounce visualViewport resize events
      clearTimeout(viewportResizeTimeout);
      viewportResizeTimeout = setTimeout(() => {
        handleResize();
      }, 300);
    });
  }
  
  // Modal close handler
  if (modalClose) {
    modalClose.addEventListener('click', hideModal);
  }
  
  // Close modal on outside click
  document.addEventListener('click', (e) => {
    if (modalContainer && modalContainer.style.display === 'block') {
      if (!modalContainer.contains(e.target) && !e.target.closest('path[id]') && !e.target.closest('.city-label')) {
        hideModal();
      }
    }
  });
}

// Start when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

